import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Home from './pages/Home';
import StatePage from './pages/State';
import CityPage from './pages/City';
import CategoryPage from './pages/Category';
import BusinessView from './pages/BusinessView';
import NotFound from './pages/NotFound';

import Header from './components/Header';
import Footer from './components/Footer';

const DirectoryLayout = () => (
  <div className="app">
    <Header />
    <main style={{ paddingTop: '72px' }}>
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route element={<DirectoryLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/in/:stateSlug" element={<StatePage />} />
          <Route path="/in/:stateSlug/:citySlug" element={<CityPage />} />
          <Route path="/in/:stateSlug/:citySlug/:categorySlug" element={<CategoryPage />} />
        </Route>
        <Route path="/:stateSlug/:citySlug/:slug" element={<BusinessView />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ThemeProvider>
  );
}
